import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { AdIdColumn as AdIdColumnConfig } from '@bingads-webui-campaign/ads-data';

export class AdIdColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const title = i18n.getString('ColumnName_AdId');

    super({
      ...AdIdColumnConfig,
      title,
      sortable: 'Id',
      type: 'number',
      helpId: 'Page_CampaignGrids_AdID',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
  }
}
